import {
    OBTENER_PAISES,
    AGREGAR_PAIS,
    ELIMINAR_PAIS,
    ACTUALIZAR_PAIS,
    PAIS_OK,
    PAIS_ERROR,
    PAIS_ACTUAL,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_PAISES:
            return {
                ...state,
                paises: action.payload.rows
            }
        case PAIS_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case PAIS_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_PAIS:
            return {
                ...state,
                paises: [...state.paises, action.payload],
                formulario: false,
                errorformulario: false
            }
        case PAIS_ACTUAL:
            return {
                ...state,
                pais: state.paises.filter(pais => pais.id === action.payload)
            }
        case ELIMINAR_PAIS:
            return {
                ...state,
                paises: state.paises.filter(pais => pais.id !== action.payload),
                pais: null
            }
        case ACTUALIZAR_PAIS:
            return {
                ...state,
                paises: state.paises.map(pais => pais.id === action.payload.id ? action.payload : pais),
                pais: action.payload
            }
        default:
            return state;
    }
}